/* src/app/admin/client/client-area/client-area-endorsement/create-or-update-endorsement.component.scss */
.input-with-symbol {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
}
.input-with-symbol .symbol {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
  pointer-events: none;
  font-size: 0.95em;
  z-index: 2;
  background: transparent;
  padding: 0 2px;
}
.input-with-symbol input,
.input-with-symbol textarea {
  padding-left: 36px;
  position: relative;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
}
.input-with-symbol .symbol.right {
  left: auto;
  right: 12px;
}
.input-with-symbol input.with-right-symbol,
.input-with-symbol textarea.with-right-symbol {
  padding-right: 36px;
  padding-left: 12px;
}
.readonly-dropdown {
  pointer-events: none;
  color: #eee;
}
.button-back {
  border-color: #747679;
  color: #747679;
}
/*# sourceMappingURL=create-or-update-endorsement.component-BWOTA6HN.css.map */
